export default "__VITE_ASSET__BwGerVak__"